import CategoryList from "../Shop/CategoryList"; // Імпортуємо CategoryList
import styles from "./CategoryMenu.module.scss"; // Стилі для CategoryMenu

interface CategoryMenuProps {
  selectedCategory: string | null;
  onSelectCategory: (id: string | null) => void;
  isOpen: boolean;
  onClose: () => void;
}

const CategoryMenu: React.FC<CategoryMenuProps> = ({
  selectedCategory,
  onSelectCategory,
  isOpen,
  onClose,
}) => {
  return (
    <div>
      {isOpen && (
        <div className={styles.menuCategoryOverlay} onClick={onClose}>
          <div
            className={styles.menuCategotyContent}
            onClick={(e) => e.stopPropagation()} // Перешкоджаємо закриттю при кліку всередині
          >
            <CategoryList
              selectedCategory={selectedCategory}
              onSelectCategory={onSelectCategory}
              isMenu={true}
              onClose={onClose}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryMenu;
